import React, { Component } from 'react';
import DatePicker from 'react-widgets/DatePicker';
import moment from 'moment';
import { isNaN, isNil } from 'lodash';
import { HeaderField } from 'new/elements/FieldBuilderRedesigned/FieldBuilder';
import { ReactComponent as CalendarIcon } from 'new/components/icons/calendar.svg';

import './DateTimeField.scss';

moment.locale('en');

const MIN_DATE = () => new Date(Date.UTC(70, 0, 1, 0, 0, 0));
const styles = {
  container: {
    marginTop: 8,
    marginBottom: 8,
    fontSize: 12,
  },
};

class DateTimeField extends Component {
  constructor(props) {
    super(props);
    this._handleChange = this._handleChange.bind(this);
  }

  _handleChange(newValue) {
    const { onChange } = this.props;
    let newUnixMs = moment(newValue).valueOf();
    if (isNil(newUnixMs) || isNaN(newUnixMs)) {
      newUnixMs = null;
    }

    onChange(newUnixMs);
  }

  render() {
    const { label, description, value, labelClassName, className, datePickerProps, customStyles } =
      this.props;

    const time = value ? moment(value).toDate() : null;

    return (
      <div
        className={className}
        style={customStyles ? { ...styles.container, ...customStyles.container } : styles.container}
      >
        {label && (
          <HeaderField className={labelClassName} item={{ display_name: label, description }} />
        )}
        <DatePicker
          data-testid={this.props['data-testid']}
          value={time}
          selectIcon={<CalendarIcon />}
          valueFormat={{ dateStyle: 'long', timeStyle: 'short' }}
          min={MIN_DATE()}
          onChange={this._handleChange}
          includeTime={true}
          {...datePickerProps}
        />
      </div>
    );
  }
}

DateTimeField.defaultProps = {
  label: null,
  description: null,
};

export default DateTimeField;
